import { Polygon } from "@vis.gl/react-google-maps";

import { PROXIMITY_BAND_COLORS } from "helpers/mapColors";

const FILL_OPACITY = 0.15;
const STROKE_OPACITY = 0.9;
const STROKE_WEIGHT = 1.5;

// Inner bands paint over outer ones so a shared boundary shows the nearer band's
// stroke, which is the edge an analyst is reading.
const BAND_Z_INDEX = { red: 1, yellow: 2, green: 3 };

// A band's second ring is its hole, and Google fills a multi-path polygon by the
// even-odd rule, so the bands come out as flat non-overlapping annuli.
const toPaths = coordinates =>
  coordinates.map(ring => ring.map(([lng, lat]) => ({ lat, lng })));

/**
 * The tenant's proximity bands, drawn around a map's address pins.
 *
 * Must be rendered inside a `Map`, whose context the polygons attach to.
 */
export function ProximityRings({ geoJson, visible = true }) {
  if (!visible) return null;

  return geoJson.features.map(feature => {
    const { band } = feature.properties;
    const color = PROXIMITY_BAND_COLORS[band];

    return (
      <Polygon
        key={feature.id}
        paths={toPaths(feature.geometry.coordinates)}
        fillColor={color}
        fillOpacity={FILL_OPACITY}
        strokeColor={color}
        strokeOpacity={STROKE_OPACITY}
        strokeWeight={STROKE_WEIGHT}
        zIndex={BAND_Z_INDEX[band]}
        // The bands are a backdrop to read marker positions against; leaving
        // them clickable would swallow clicks meant for the markers on top.
        clickable={false}
      />
    );
  });
}
